import { Badge } from "@aircall/ds";
import { useTranslation } from "react-i18next";

export function BetaTag() {
  const { t } = useTranslation("common");
  return (
    <Badge color="blue" tone="medium-light" className="uppercase">
      {t("Beta")}
    </Badge>
  );
}
